
    export default {
        name: 'C1Disclosure',
    };
